module.exports = __webpack_public_path__ + "media/Kochen.e6b2f828.mp3";